import type { UpcomingTickets } from '@cobliteam/api-lib/src/__generated__/graphql';

type TicketLike = NonNullable<NonNullable<UpcomingTickets['tickets']>[number]>;

const pickUnits = (ticket: TicketLike): number | undefined => {
  const total = ticket.deviceTotalQuantity?.total;
  return typeof total === 'number' ? total : undefined;
};

export type ComputeUpcomingFleetSizeInput = {
  currentFleetSize: number;
  upcomingTickets?: UpcomingTickets | null;
};

export const computeUpcomingFleetSize = ({ currentFleetSize, upcomingTickets }: ComputeUpcomingFleetSizeInput): number | undefined => {
  if (!upcomingTickets?.tickets?.length) return undefined;

  const tickets = upcomingTickets.tickets.filter((ticket): ticket is TicketLike => ticket != null);
  const returnsUnits = tickets.filter((ticket) => ticket.type === 'Return' || ticket.type === 'RETURN').reduce((acc, ticket) => acc + (pickUnits(ticket) ?? 0), 0);
  const upsellUnits = upcomingTickets.hasUpsell
    ? tickets.filter((ticket) => ticket.type === 'Shipping' || ticket.type === 'SHIPPING').reduce((acc, ticket) => acc + (pickUnits(ticket) ?? 0), 0)
    : 0;

  if (returnsUnits === 0 && upsellUnits === 0) return undefined;

  const next = currentFleetSize + upsellUnits - returnsUnits;
  return Math.max(0, next);
};
